import { useAppDispatch, useAppSelector } from '~/redux/hooks'
import {
  selectIsChatAiLoading,
  setChatAiIsOpenActionCreator,
  setThreadChatMessageEmptyActionCreator,
} from '~/redux/slices/chat-ai'

import useOracleMessage from './useOracleMessage'

export default function useActivityHint(): (
  value: string,
  image: string,
  activityTypes?: string,
  ansHistory?: string[],
) => void {
  const dispatch = useAppDispatch()
  const { onSendMessageClick } = useOracleMessage()
  const isLoading = useAppSelector(selectIsChatAiLoading)

  const sendToOracleAI = (value: string, image: string, activityTypes?: string, ansHistory?: string[]): void => {
    if (!isLoading) {
      dispatch(setThreadChatMessageEmptyActionCreator())
      dispatch(setChatAiIsOpenActionCreator(true))
      onSendMessageClick(value, '', image, false, undefined, undefined, true, activityTypes, ansHistory)
    }
  }

  return sendToOracleAI
}
